export default __webpack_public_path__ + "static/media/PDFReport-Interior-Pg2.87a4e64f.png";